import axios from 'axios';

export default {
    methods: {
        async novedadIndex(page, ok, err) {
            try {
                let r = await axios.get('novedad?page=' + page)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async novedadStore(d, ok, err) {
            try {
                let r = await axios.post('novedad', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async novedadUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('novedad/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async novedadShow(id, ok, err) {
            try {
                let r = await axios.get('novedad/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/novedad.js